export enum LiveUserNotificationPlaces {
  HOME = 'home',
  AI_CONTENT_DETECTOR = 'ai_content_detector',
  AI_TEXT_HUMANIZER = 'ai_text_humanizer',
  CHECK_PLAGIARISM = 'check_plagiarism',
}

export enum LiveUserNotificationVariants {
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
}

type LiveUserNotificationsFeatureConfig = {
  place: LiveUserNotificationPlaces;
  message: string;
  variant: LiveUserNotificationVariants;
};

type SurveyMonkeyFeatureConfig = {
  total_generations: number;
  days_from_registration: number;
  show_page: string;
  survey_id: string;
  profession: string;
};

export enum GB_FEATURE_KEYS {
  LIVE_USER_NOTIFICATIONS = 'live_user_notifications',
  EXTENSION_SURVEYMONKEY_INTEGRATION = 'experiment-surveymonkey-integration',
  LATAM_PLAGIARISM_COST_CUTTING = 'experiment-latam-plagiarism-cost-cutting',
  CANCEL_FLOW = 'experiment-cancel-flow',
  COMPLIANCE = 'compliance',
  CANCEL_FLOW_FROZEN_SUBSCRIPTION_BLOCK = 'cancel-flow-frozen-subscription-block',
  POLICY_ENGINE_TOOL_ROUTES = 'policy-engine-tool-routes',
  BILLING_HISTORY = 'billing-history',
  JUSTDONE_ONBOARDING_FLOW = 'experiment-justdone-onboarding-flow',
  PAYPAL_PAYMENT = 'paypal-payment',
}

export const GB_FEATURES = {
  [GB_FEATURE_KEYS.LATAM_PLAGIARISM_COST_CUTTING]: {
    key: GB_FEATURE_KEYS.LATAM_PLAGIARISM_COST_CUTTING,
    variants: {
      control: 'control',
      variant_1: 'test',
    },
    defaultVariant: 'control',
  },
  [GB_FEATURE_KEYS.EXTENSION_SURVEYMONKEY_INTEGRATION]: {
    key: GB_FEATURE_KEYS.EXTENSION_SURVEYMONKEY_INTEGRATION,
    variants: {
      control: 'control',
      variant_1: 'test',
    },
    defaultVariant: {
      total_generations: 0,
      days_from_registration: 0,
      profession: 'student',
      show_page: '/',
      survey_id:
        'tRaiETqnLgj758hTBazgd_2FCq31UvmncXYVkjbhPhd5241YDIWzKtfHyoGc_2FOY8MW',
    } as SurveyMonkeyFeatureConfig,
  },
  [GB_FEATURE_KEYS.LIVE_USER_NOTIFICATIONS]: {
    key: GB_FEATURE_KEYS.LIVE_USER_NOTIFICATIONS,
    variants: {
      control: 'control',
      variant_1: 'test',
    },
    defaultVariant: [
      {
        place: '' as LiveUserNotificationPlaces,
        message: '',
        variant: '' as LiveUserNotificationVariants,
      },
    ] as LiveUserNotificationsFeatureConfig[],
  },
  [GB_FEATURE_KEYS.CANCEL_FLOW]: {
    key: GB_FEATURE_KEYS.CANCEL_FLOW,
    variants: {
      control: 'control',
      variant_2: 'test-b',
      variant_3: 'test-c',
    },
    defaultVariant: 'control',
  },
  [GB_FEATURE_KEYS.CANCEL_FLOW_FROZEN_SUBSCRIPTION_BLOCK]: {
    key: GB_FEATURE_KEYS.CANCEL_FLOW_FROZEN_SUBSCRIPTION_BLOCK,
    variants: {
      control: false,
      variant_1: true,
    },
    defaultVariant: false as boolean,
  },
  [GB_FEATURE_KEYS.BILLING_HISTORY]: {
    key: GB_FEATURE_KEYS.BILLING_HISTORY,
    variants: {
      control: false,
      variant_1: true,
    },
    defaultVariant: false as boolean,
  },
  [GB_FEATURE_KEYS.JUSTDONE_ONBOARDING_FLOW]: {
    key: GB_FEATURE_KEYS.JUSTDONE_ONBOARDING_FLOW,
    variants: {
      control: 'control',
      test: 'test',
    },
    defaultVariant: 'control',
  },
  [GB_FEATURE_KEYS.PAYPAL_PAYMENT]: {
    key: GB_FEATURE_KEYS.PAYPAL_PAYMENT,
    variants: {
      control: true,
      variant_1: false,
    },
    defaultVariant: true,
  },
};

export const GB_ROUTE_FEATURES = {
  [GB_FEATURE_KEYS.POLICY_ENGINE_TOOL_ROUTES]: {
    key: GB_FEATURE_KEYS.POLICY_ENGINE_TOOL_ROUTES,
    variants: {
      v1: 'v1',
      v2: 'v2',
    },
    defaultVariant: 'v1',
  },
};

export type GBFeatureKey = keyof typeof GB_FEATURES;

export type GBRouteFeatureKey = keyof typeof GB_ROUTE_FEATURES;

export type FeatureVariant<K extends GBFeatureKey> =
  (typeof GB_FEATURES)[K]['defaultVariant'];

export type RouteFeatureVariant<K extends GBRouteFeatureKey> =
  (typeof GB_ROUTE_FEATURES)[K]['defaultVariant'];
